export default "__VITE_ASSET__BXef9BOl__"